
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="py-24 px-8 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-gray-500 mb-4">
            Hakkımızda
          </p>
          <div className="space-y-6 text-gray-800">
            <p className="font-serif text-2xl leading-relaxed">
              MSB Tesis Güvenlik Belgesi süreçlerinde 10 yılı aşkın deneyimimizle, savunma sanayi firmalarına profesyonel danışmanlık hizmeti sunuyoruz. 5188 sayılı Özel Güvenlik Hizmetlerine Dair Kanun ve ilgili yönetmeliklere tam hakimiyetimizle, belgelendirme sürecinizin her aşamasında yanınızdayız.
            </p>
            <p className="font-serif text-2xl leading-relaxed">
              Milli ve NATO Tesis Güvenlik Belgesi başvurularında, fiziki güvenlik altyapısı kurulumundan personel güvenlik soruşturmalarına kadar tüm süreçlerde uçtan uca destek sağlıyoruz. Amacımız, firmanızın gizlilik dereceli projelere katılımını en kısa sürede ve en yüksek standartlarda gerçekleştirmektir.
            </p>
          </div>
          
          <Link
            to="/hakkimizda"
            className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Daha Fazla Bilgi
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-12 mt-20">
          <div className="text-center">
            <div className="text-7xl font-bold text-[#1E3A5F] mb-2">150+</div>
            <div className="text-gray-600 font-medium">Tamamlanan Belge</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-[#1E3A5F] mb-2">12</div>
            <div className="text-gray-600 font-medium">Yıllık Deneyim</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-[#1E3A5F] mb-2">96%</div>
            <div className="text-gray-600 font-medium">Başarı Oranı</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-[#1E3A5F] mb-2">80+</div>
            <div className="text-gray-600 font-medium">Danışmanlık Verilen Firma</div>
          </div>
        </div>
      </div>
    </section>
  );
}
